const MenuClose = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
        {...props}
    >
        <path
            d="M3 3L13 13M13 3L3 13"
            stroke="#534E46"
            strokeWidth="1.5"
            strokeLinecap="round"
        />
    </svg>
)

export default MenuClose
